import React from 'react'
import { EndPointUserDetails } from '../../services/common/endpoints';
import { useQuery } from 'react-query';
import { useTranslation } from 'react-i18next';
import Loadingcomponent from '../loader/loadingcomponent';
import { getImgSrc, isContainArabicCharacters } from '../../services/common/CommonUtils';
import { getItemOfSessionStorage, isContainAlphabet } from '../../services/common/utils';
import { SELECTED_LANG } from '../../services/common/Constants';
import ProfileIcon from '../loader/skeletons/profile-icon';

function UserProfile() {
    const { t } = useTranslation();
    const lang = getItemOfSessionStorage(SELECTED_LANG);
    const userDetailsQr = useQuery(["rn-user-details", EndPointUserDetails.url, EndPointUserDetails.data, {},],
        {
            retry: false,
            retryOnMount: false,
            cacheTime: 0,
            staleTime: 0,
        },
    );

    if (userDetailsQr.isLoading) {
        // return <Loadingcomponent />
        return <ProfileIcon />
    }

    const imagePath = userDetailsQr?.data?.data?.response?.profilepic || '/assets/images/sprint16/ooredoo-sm-logo.svg';
    const isServerUrl = userDetailsQr?.data?.data?.response?.profilepic ? true : false;
    let nickname = '';

    if (userDetailsQr?.data?.data?.response?.nickname) {
        nickname = userDetailsQr?.data?.data?.response?.nickname;
        // if (lang === 'ar') {
        //     nickname = isContainAlphabet(nickname) ? `${nickname} ${t("number")}` : `${t("number")} ${nickname}`;
        // } else {
        //     nickname = `${nickname} ${t("number")}`;
        // }

        if(isContainArabicCharacters(nickname) && !isContainAlphabet(nickname)){
            // console.log('==> only ar chars');
            nickname = lang === 'en' ? `${nickname} ${t("number")}` : `${t("number")} ${nickname}`
        }else if(isContainAlphabet(nickname) && !isContainArabicCharacters(nickname)){
            // console.log('==> only en chars');
            nickname = lang === 'en' ? `${nickname} ${t("number")}` : `${t("number")} ${nickname}`
        }else if(isContainAlphabet(nickname) && isContainArabicCharacters(nickname)){
            // console.log('==> both en and ar chars');
            nickname = lang === 'en' ? `${nickname} ${t("number")}` : `${t("number")} ${nickname}`
        }
    }

    //   for test
    //  let name4 = '';
    //  let name1 = 'امتحان'; // Done
    //  let name5 = 'الاسم الأول'; // Done
    //  let name3 = 'test';
    //  let name31 = 'test new';
    //  let name2 = 'test امتحان';

    return (
        <div class="d-flex align-items-center flex-column mt-5 linedetails_img">
            <div class="w-100 linedetails-userimg">
                <hr />
                <div class="sprint14-userimg">
                    <img src={getImgSrc(imagePath, isServerUrl)} alt="profile-pic" />
                </div>
            </div>

            <h5 className={`mt-3 font-bold`}>
                {
                    nickname && (
                        <>{nickname}</>
                    )
                }
                {/* {
                    nickname && (
                        <>{isContainAlphabet(nickname) ? `${nickname}'s` : `s'${nickname}`} {t("number")}</>
                    )
                } */}

                {/* {
                    name5 && (
                        <>
                            {
                                isArabicTextWithSpace ? (
                                    <>{t("number")} {`${name5}`}</>
                                ) : (
                                    <>{isContainAlphabet(name5) ? `${name5}` : `${name5}`} {t("number")}</>
                                )
                            }
                        </>
                    )
                } */}

                {/* {
                    name2 && (
                        <>{isContainAlphabet(name2) ? `${name2} ${t("number")}` : `${t("number")} ${name2}`}</>
                    )
                } */}
            </h5>
            {/* {
                lang == "ar" ? (<>{nickname &&
                 <div className='mt-3'>
            <h5 style={{display: 'inline'}}>{` ${t("number") } `}</h5>
            <h5 style={{direction: isContainAlphabet(nickname) ? "ltr" : "", display: 'inline-flex'}}> {nickname}</h5>
            </div>
            }</>) :(<>{nickname &&
                    <div className='mt-3'>
            <h5 style={{direction: isContainAlphabet(nickname) ? "ltr" : "", display: 'inline-flex'}}> {nickname}</h5>
            <h5 style={{display: 'inline'}}>{` ${t("number") } `}</h5>
            </div>
                }</>)
            } */}
           
        </div>
    )
}

export default UserProfile;